module.exports = __webpack_public_path__ + "static/media/logo-serios.d277a5ff.svg";